import React, { useEffect } from 'react';
import useFilters from '../../../hooks/useFilters';
import { fillObject, hasValues } from '../../../utils/Utils';
import Button from '../../Button/Button';
import OutsideAlerter from '../../OutsideAlerter/OutsideAlerter';
import Span from '../../Texts/Span/Span';
import Card from '../../Card/Card';
import { Provider as FilterContext } from '../FilterContext.inner.js';

import * as S from '../Filters.styles';
import FiltersChilds from '../FiltersChilds.inner';

const AdvancedFilters = ({
  filters,
  children,
  open,
  onChange,
  onCancel,
  invertPosition,
}) => {
  const { filters: advanced, setFilter, addFilters } = useFilters(filters);

  useEffect(() => addFilters(filters), [filters]);

  const handleChangeFilters = () =>
    onChange({ advanced: advancedWithNoError(advanced) });

  const advancedWithNoError = (adv) => {
    return Object.keys(adv).reduce((acc, key) => {
      const filter = adv[key];
      if (filter) {
        return { ...acc, [key]: { value: filter.value, type: filter.type } };
      }

      return { ...acc, [key]: null };
    }, {});
  };

  const handleCancel = (e) => {
    addFilters(fillObject(advanced, null));
    onCancel(e);
  };
  return (
    <FilterContext value={{ filters: advanced, setFilter }}>
      {open && (
        <OutsideAlerter
          handleOutSideClick={handleCancel}
          invertPosition={invertPosition}
        >
          <S.AdvancedFiltersPopper
            data-testid='advanced-filters-popper'
            invertPosition={invertPosition}
          >
            <Card spacing='6'>
              <S.AdvancedFiltersWrapper>
                <S.AdvancedFiltersHeader>
                  <Span type='1' variant='neutral' weight='bold'>
                    Filtrar por
                  </Span>
                </S.AdvancedFiltersHeader>
                <S.AdvancedFiltersBody>
                  <FiltersChilds setFilter={setFilter} filters={advanced}>
                    {children}
                  </FiltersChilds>
                </S.AdvancedFiltersBody>
              </S.AdvancedFiltersWrapper>
              <S.AdvancedFiltersButtons>
                <Button size='sm' variant='secondary' onClick={handleCancel}>
                  Cancelar
                </Button>
                <Button
                  size='sm'
                  variant='primary'
                  disabled={
                    !hasValues(advanced) ||
                    Object.values(advanced).some((item) => item?.error)
                  }
                  onClick={handleChangeFilters}
                >
                  Aplicar
                </Button>
              </S.AdvancedFiltersButtons>
            </Card>
          </S.AdvancedFiltersPopper>
        </OutsideAlerter>
      )}
    </FilterContext>
  );
};

AdvancedFilters.displayName = 'AdvancedFilters';

export default AdvancedFilters;
